export default __webpack_public_path__ + "media/src/features/home-page-redesign/assets/mobileAmenities-d41829f3a562e8da93cdcde858d867d7.svg";